import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandleAutoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M3 18c5 0 5-12 9-12s4 12 9 12" }), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 6,
		r: 2,
		fill: "currentColor",
		stroke: "none"
	})]
});
export default SvgHandleAutoIcon;
